const CODE_FRAGMENT_KEYS = ['code=', 'error=', 'id_token='];

export const isMsalPopupFlow = (): boolean => {
  if (typeof window === 'undefined') return false;

  const { hash, search } = window.location;
  const fragment = hash || search;

  const hasAuthParams = CODE_FRAGMENT_KEYS.some((key) =>
    fragment.includes(key)
  );

  return Boolean(window.opener) && hasAuthParams;
};
